import React from 'react';

const hoy = () => new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);
const restar = (dias) => new Date(Date.now() - dias * 86400000 - 3 * 3600 * 1000).toISOString().slice(0, 10);
const inicioDeMes = () => hoy().slice(0, 7) + '-01';

/* El mes pasado completo, del 1 al último día.

   No se calcula restando 30 días: el 31 de marzo menos 30 cae en marzo, y el
   período saldría del mes equivocado. Se toma el día anterior al 1 de este mes
   —que siempre es el último del anterior— y de ahí el primero de ese mes. */
const mesPasado = () => {
  const h = new Date(Date.now() - 3 * 3600 * 1000);
  const fin = new Date(Date.UTC(h.getUTCFullYear(), h.getUTCMonth(), 0));
  const ini = new Date(Date.UTC(fin.getUTCFullYear(), fin.getUTCMonth(), 1));
  return { desde: ini.toISOString().slice(0, 10), hasta: fin.toISOString().slice(0, 10) };
};

// Presets de período. Devuelve { desde, hasta, preset }
export const PRESETS = {
  semana: { label: 'Última semana', corto: '7 días', calcular: () => ({ desde: restar(7), hasta: hoy() }) },
  mes: { label: 'Últimos 30 días', corto: '30 días', calcular: () => ({ desde: restar(30), hasta: hoy() }) },
  actual: { label: 'Mes en curso', corto: 'Este mes', calcular: () => ({ desde: inicioDeMes(), hasta: hoy() }) },
  pasado: { label: 'Mes pasado', corto: 'Mes pasado', calcular: mesPasado },
  anio: { label: 'Este año', corto: 'Este año', calcular: () => ({ desde: hoy().slice(0, 4) + '-01-01', hasta: hoy() }) },
  doce: { label: 'Últimos 12 meses', corto: '12 meses', calcular: () => ({ desde: restar(365), hasta: hoy() }) },
  /* "Todo" no puede terminar hoy: un cobro que vence la semana que viene es
     parte de todo. Sin tope superior entran también los futuros y los "a pasar",
     que es lo que hace que la pantalla de Cobros sirva como cashflow completo. */
  todo: { label: 'Todo', corto: 'Todo', calcular: () => ({ desde: '2020-01-01', hasta: '' }) },
  custom: { label: 'Personalizado', corto: 'Elegir', calcular: () => ({ desde: inicioDeMes(), hasta: hoy() }) },
};

export const TODAS = ['semana', 'mes', 'actual', 'pasado', 'anio', 'doce', 'todo', 'custom'];

export const rangoInicial = (preset = 'doce') => ({ preset, ...PRESETS[preset].calcular() });

/* El filtro de período, igual en las tres plataformas.

   En el celular los siete botones se acomodaban en cuatro renglones y el bloque
   se comía media pantalla antes de mostrar un solo dato. Ahora van en una fila
   que se desliza para el costado: siempre una línea de alto, y la opción
   elegida se centra sola al entrar. Las fechas a medida bajan abajo, en su
   propio renglón, con su etiqueta. */
export default function RangoFechas({ valor, onChange, opciones = TODAS, derecha }) {
  const fila = React.useRef(null);
  const elegir = (k) => onChange({ preset: k, ...PRESETS[k].calcular() });

  // que la opción activa quede a la vista, aunque esté al final de la fila
  React.useEffect(() => {
    const act = fila.current?.querySelector('.chip-periodo.activo');
    act?.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [valor.preset]);

  return (
    <div className="filtro-fechas">
      <div className="filtro-fechas-fila" ref={fila}>
        {opciones.map(k => (
          <button key={k} type="button" onClick={() => elegir(k)}
            className={'chip-periodo' + (valor.preset === k ? ' activo' : '')}
            aria-pressed={valor.preset === k}>
            <span className="solo-pc">{PRESETS[k].label}</span>
            <span className="solo-cel">{PRESETS[k].corto}</span>
          </button>
        ))}
        {derecha && <div className="filtro-fechas-derecha">{derecha}</div>}
      </div>

      {valor.preset === 'custom' && (
        <div className="filtro-fechas-custom">
          <label>
            <span>Desde</span>
            <input type="date" value={valor.desde} max={valor.hasta}
              onChange={e => onChange({ ...valor, desde: e.target.value })} />
          </label>
          <label>
            <span>Hasta</span>
            <input type="date" value={valor.hasta} min={valor.desde}
              onChange={e => onChange({ ...valor, hasta: e.target.value })} />
          </label>
        </div>
      )}
    </div>
  );
}
